import { Badge } from '@/components/ui/badge';
import { statusBadgeClass, roleBadgeClass } from '@/lib/status';

// Reusable status chip using the central green/grey scheme.
export function StatusBadge({ status, className = '' }: { status?: string | null; className?: string }) {
  return <Badge variant="outline" className={`${statusBadgeClass(status)} ${className}`.trim()}>{status || '—'}</Badge>;
}

// Reusable role chip using the central role color map.
export function RoleBadge({ role, className = '' }: { role?: string | null; className?: string }) {
  return <Badge variant="outline" className={`${roleBadgeClass(role)} ${className}`.trim()}>{role || '—'}</Badge>;
}
